"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebsocket = void 0;
const react_1 = require("react");
const stompjs_1 = require("@stomp/stompjs");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const lodash_1 = require("lodash");
function useWebsocket({ wsUrl, destinations, debug, }) {
    /**
     * Reference to websocket client.
     */
    const client = react_1.useRef();
    /**
     * Array of subscription references.
     */
    const subscribtions = react_1.useRef([]);
    /**
     * True if connection has been successfully established.
     */
    const [isWsActive, setIsWsActive] = react_1.useState(false);
    /**
     * Received message useWebsocketEffect reacts to.
     */
    const [message, setMessage] = react_1.useState('');
    /**
     * Subscribe method.
     */
    const subscribe = event_callback_hook_1.useEventCallback((destination, callback) => {
        var _a;
        const subscription = (_a = client.current) === null || _a === void 0 ? void 0 : _a.subscribe(destination, (msg) => {
            if (callback) {
                callback(msg);
            }
            else {
                setMessage(msg.body);
            }
        });
        if (subscription) {
            subscribtions.current.push(subscription);
        }
        return subscription;
    });
    /**
     * Unsubscribe method.
     */
    const unsubscribe = event_callback_hook_1.useEventCallback((subscription) => {
        if (subscription) {
            // console.log('unsubscribing', subscription, subscribtions);
            subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
            subscribtions.current = subscribtions.current.filter((s) => s !== subscription);
        }
    });
    /**
     * Establish connection on mount && clear on unmount.
     */
    react_1.useEffect(() => {
        // construct full url
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const fullUrl = `${protocol}//${window.location.hostname}:${window.location.port}${wsUrl}`;
        client.current = new stompjs_1.Client({
            brokerURL: fullUrl,
            debug: debug
                ? function (str) {
                    console.log(str);
                }
                : lodash_1.noop,
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000,
        });
        client.current.activate();
        client.current.onConnect = () => {
            setIsWsActive(true);
            destinations.forEach((destination) => subscribe(destination));
        };
        client.current.onDisconnect = () => {
            setIsWsActive(false);
            subscribtions.current.forEach((subscription) => unsubscribe(subscription));
        };
        return () => {
            var _a;
            (_a = client.current) === null || _a === void 0 ? void 0 : _a.deactivate();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const context = react_1.useMemo(() => ({
        isWsActive,
        client,
        subscribe,
        unsubscribe,
        message,
        setMessage,
    }), [isWsActive, message, subscribe, unsubscribe]);
    return {
        context,
    };
}
exports.useWebsocket = useWebsocket;
//# sourceMappingURL=web-socket-hook.js.map